import { stylize } from "@envestnet/envreact-component-library";
import React from "react";
import withIntl from "utils/withIntl";
import messages from "./messages";
import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;
}

interface DefaultProps {}

export interface DashboardMfaLayoutProps extends DefaultProps {
  /** Description of this prop */
  children: JSX.Element;
}

const defaultProps: DefaultProps = {};

type Props = InjectedProps & DashboardMfaLayoutProps;

const DashboardMfaLayout = (props: Props) => {
  const { classes, formatMessage, children } = props;

  return (
    <>
      <div className={classes.section}>
        <div className={classes.header4}>
          <div className={classes.iconWrapper}>
            {formatMessage(messages.header)}
          </div>
        </div>
        {children}
      </div>
    </>
  );
};

DashboardMfaLayout.defaultProps = defaultProps;

export default withIntl(
  stylize<Props, DefaultProps>(styles)(DashboardMfaLayout)
);
